package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.platform.FileListFetcher
import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import com.eladfinish.bible.contest.screens.mikud.usecases.GetChaptersInMikudAsArrayListUseCase
import com.eladfinish.bible.contest.screens.search.model.SearchPlace
import com.eladfinish.bible.contest.screens.search.model.SearchPlaceData
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList
import kotlinx.io.IOException

class GetSearchedChaptersUseCase(
    private val fileListFetcher: FileListFetcher,
    private val mikudRepository: MikudRepository,
    private val getChaptersInMikudAsArrayListUseCase: GetChaptersInMikudAsArrayListUseCase,
) {

    operator fun invoke(searchPlace: SearchPlace): ImmutableList<SearchPlaceData> {
        try {
//            val a: SharedRes.assets.allChapters = SharedRes.assets.allChapters
            val allChaptersList = fileListFetcher.fetchFileList(StringConstants.ALL_CHAPTERS)
                .sortedInBibleOrder()
            return when (searchPlace) {
                SearchPlace.WHOLE_BIBLE -> allChaptersList
                SearchPlace.BY_MIKUD -> getChaptersInMikudAsArrayListUseCase(mikudStr = mikudRepository.mikudList)
            }.attachBookNumber().toImmutableList()
        } catch (e: IOException) {
            AppCrashlytics.logException(e)
        }
        return emptyList<SearchPlaceData>().toImmutableList()
    }

    private fun List<String>.attachBookNumber(): List<SearchPlaceData> =
        map {
            SearchPlaceData(
                bookIndex = ChaptersRepository.getBookNumber(chapterFilename = it),
                filename = it,
            )
        }
}

/**
 * Chapter asset filenames (`_<book>_<name>-<chapter>.txt`) in the order of the Bible: by book
 * number — numerically, so `_2_…` precedes `_10_…` — then by filename, whose zero-padded chapter
 * number sorts chapters within a book.
 *
 * The second key matters: the platform listing is not ordered everywhere (iOS's
 * `contentsOfDirectoryAtPath` returns directory order), and sorting by book alone left the
 * chapters of each book — and therefore the search results — shuffled there.
 */
internal fun List<String>.sortedInBibleOrder(): List<String> =
    sortedWith(compareBy<String> { ChaptersRepository.getBookNumber(it) }.thenBy { it })
